import React from 'react';
import PropTypes from 'prop-types';


export default (Component) => {
    function WithContextPath(props, context) {
        return <Component {...props} contextPath={context.contextPath} />;
    }

    WithContextPath.contextTypes = {
        contextPath: PropTypes.string,
    };

    return WithContextPath;
};



// WEBPACK FOOTER //
// ./src/frontend/components/contextpath/withContextPath.jsx